<template>
  <div class="row g-4">
    <div class="col-lg-6 col-12">
      <div class="form-field"><label class="field-label">اسم الأستاذ</label><InputText v-model="local.name_line" class="w-100" /></div>
    </div>
    <div class="col-lg-6 col-12">
      <div class="form-field"><label class="field-label">اللقب</label><InputText v-model="local.title_line" class="w-100" /></div>
    </div>
    <div class="col-12">
      <div class="form-field"><label class="field-label">نص الحقوق</label><InputText v-model="local.credit_text" class="w-100" /></div>
    </div>

    <div class="col-12">
      <label class="field-label d-block mb-2">روابط الموقع</label>
      <div v-for="(link, idx) in local.legal_links" :key="idx" class="answer-item">
        <div class="answer-item__index">{{ idx + 1 }}</div>
        <div class="answer-item__content">
          <div class="stat-row">
            <InputText v-model="link.label" placeholder="النص" class="w-100" />
            <InputText v-model="link.link" placeholder="الرابط" class="w-100" />
          </div>
        </div>
        <div class="answer-item__actions"><button type="button" class="answer-remove-btn" @click="local.legal_links.splice(idx,1)"><i class="pi pi-trash"></i></button></div>
      </div>
      <button type="button" class="add-answer-btn" v-if="local.legal_links.length < 10" @click="local.legal_links.push({ label: '', link: '' })">
        <i class="pi pi-plus"></i> إضافة رابط
      </button>
    </div>

    <div class="col-12">
      <label class="field-label d-block mb-2">روابط التواصل الاجتماعي</label>
      <div v-for="(social, idx) in local.socials" :key="idx" class="answer-item">
        <div class="answer-item__index">{{ idx + 1 }}</div>
        <div class="answer-item__content">
          <div class="stat-row stat-row--3">
            <select v-model="social.icon" class="accent-select">
              <option value="facebook">فيسبوك</option>
              <option value="whatsapp">واتساب</option>
              <option value="phone">هاتف</option>
            </select>
            <InputText v-model="social.url" placeholder="الرابط" class="w-100" />
          </div>
        </div>
        <div class="answer-item__actions"><button type="button" class="answer-remove-btn" @click="local.socials.splice(idx,1)"><i class="pi pi-trash"></i></button></div>
      </div>
      <button type="button" class="add-answer-btn" v-if="local.socials.length < 6" @click="local.socials.push({ icon: 'facebook', url: '' })">
        <i class="pi pi-plus"></i> إضافة رابط تواصل
      </button>
    </div>
  </div>
</template>

<script setup>
import { reactive, watch } from 'vue';
import InputText from 'primevue/inputtext';

const props = defineProps({ modelValue: { type: Object, default: () => ({}) } });
const emit = defineEmits(['update:modelValue']);

const local = reactive({
  name_line: props.modelValue.name_line ?? '',
  title_line: props.modelValue.title_line ?? '',
  credit_text: props.modelValue.credit_text ?? '',
  legal_links: (props.modelValue.legal_links ?? []).map((l) => ({ ...l })),
  socials: (props.modelValue.socials ?? []).map((s) => ({ ...s })),
});

watch(local, () => emit('update:modelValue', { ...props.modelValue, ...local }), { deep: true });
</script>

<style scoped>
.stat-row { display: grid; grid-template-columns: 1fr 1fr; gap: .5rem; }
.stat-row--3 { grid-template-columns: 130px 1fr; }
.accent-select { border: 1px solid var(--border, #e5e7eb); border-radius: 8px; padding: 0 .5rem; }
</style>
